// Open cart drawer when adding to cart, wait half a second so the cart is updated
document.addEventListener('theme:cart:add',(event)=>{
  let cartButton = document.getElementById('cartTotal');
  setTimeout(()=>{   
    cartButton.click();
  },500);
});